<template>
  <div class="app-container">
    <div class="title-row"><span class="title">{{ this.$route.meta.title }}</span></div>
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="省份名称" prop="provinceName">
        <el-input v-model="queryParams.provinceName" placeholder="请输入省份名称" clearable style="width: 240px" @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button v-hasPermi="['forest:map:add']" type="primary" plain icon="el-icon-plus" size="mini" @click="handleAdd">新增</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['forest:map:export']" type="warning" plain icon="el-icon-download" size="mini" @click="handleExport">导出</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList" ></right-toolbar>
    </el-row>

    <el-table v-loading="loading" :data="provinceList"  border>
      <el-table-column type="index" :index="handleIndex" label="序号" align="center" width="60"/>
      <el-table-column label="省份名称" align="center" prop="provinceName" min-width="160" >
        <template slot-scope="scope">
          <a v-if="$auth.hasPermi('forest:area:list')" class="link-type" style="cursor:pointer" @click="handleViewData(scope.row)">{{ scope.row.provinceName }}</a>
          <span v-else>{{ scope.row.provinceName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="地区总数" align="center" prop="totalCount" min-width="120"  />
      <el-table-column label="已完成数" align="center" prop="finishedCount" min-width="120"/>
      <el-table-column label="未完成数" align="center" prop="unfinishedCount" min-width="120"/>
      <el-table-column label="完成度" align="center"  width="300">
        <template slot-scope="scope">
          <el-progress :percentage="scope.row.percentage" :stroke-width="24" :text-inside="true" :color="colors" :text-color="scope.row.percentage==0?'#f56c6c':'#FFFFFF'"	></el-progress>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="200">
        <template slot-scope="scope">
          <el-button v-hasPermi="['forest:map:edit']" size="mini" type="text" icon="el-icon-edit" @click="handleUpdate(scope.row)">修改</el-button>
          <el-button v-hasPermi="['forest:area:list']" size="mini" type="text" icon="el-icon-s-operation" @click="handleToArea(scope.row)">列表</el-button>
          <el-button v-hasPermi="['forest:map:remove']" size="mini" type="text" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.current"
      :limit.sync="queryParams.size"
      @pagination="getList"
      :page-sizes="[10, 20, 50]"
    />

    <!-- 添加或修改参数配置对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body :close-on-click-modal="false" >
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="省份名称" prop="provinceName">
          <el-input v-model="form.provinceName" placeholder="请输入省份名称" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>

    <forest-area-drawer :visible.sync="drawerVisible" :row="drawerRow" />
  </div>
</template>

<script>
import ForestAreaDrawer from './detail'
import { listForestProvince, getForestProvince, delForestProvince, addForestProvince, updateForestProvince } from '@/api/forest/province';
import DictDataDrawer from "@/views/dict/detail.vue";

export default {
  components: {DictDataDrawer, ForestAreaDrawer},
  name: "ForestProvince",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 省份表格数据
      provinceList: [],
      // 地区数据抽屉状态
      drawerVisible: false,
      // 地区数据信息
      drawerRow: {},
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        current: 1,
        size: 10,
        provinceName: undefined,
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        provinceName: [
          { required: true, message: "省份名称不能为空", trigger: "blur" }
        ]
      },
      colors: [
        { color: '#f56c6c', percentage: 10 },
        { color: '#ff8888', percentage: 20 },
        { color: '#e88a4a', percentage: 30 },
        { color: '#ffb366', percentage: 40 },
        { color: '#5cb87a', percentage: 50 },
        { color: '#66cc88', percentage: 60 },
        { color: '#3a9ce2', percentage: 70 },
        { color: '#55aaff', percentage: 80 },
        { color: '#6f7ad3', percentage: 90 },
        { color: '#7788ee', percentage: 100 }
      ]
    };
  },
  created() {
    this.getList();
  },
  methods: {
    handleIndex(index){
      return (this.queryParams.current - 1) * this.queryParams.size + (index + 1)
    },
    /** 查询省份类型列表 */
    getList() {
      this.loading = true;
      listForestProvince(this.queryParams).then(res => {
          this.provinceList = res.rows;
          this.total = res.total;
          this.loading = false;
        }
      );
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        provinceId: undefined,
        provinceName: undefined,
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.current = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加蚂蚁森林地图省份";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const provinceId = row.provinceId
      getForestProvince(provinceId).then(response => {
        this.form = response.data;
        this.open = true;
        this.title = "修改蚂蚁森林地图省份";
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.provinceId != undefined) {
            updateForestProvince(this.form).then(response => {
              this.$modal.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            });
          } else {
            addForestProvince(this.form).then(response => {
              this.$modal.msgSuccess("新增成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const provinceId = row.provinceId;
      this.$modal.confirm('是否确认删除省份名称为"' + row.provinceName + '"的数据项？').then(function() {
        return delForestProvince(provinceId);
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download('/admin/forest/province/export', {
        ...this.queryParams
      }, `蚂蚁森林地图_${new Date().getTime()}.xlsx`)
    },
    /** 地区数据抽屉显示信息 */
    handleViewData(row) {
      this.drawerRow = row
      this.drawerVisible = true
    },
    /** 所属地区 */
    handleToArea(row){
      this.$tab.openPage('森林地区','/forest/forest-area/',{provinceId:row.provinceId});
    }
  }
};
</script>
